var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50004 2.16732C4.55452 2.16732 2.16671 4.55513 2.16671 7.50065C2.16671 10.4462 4.55452 12.834 7.50004 12.834C10.4456 12.834 12.8334 10.4462 12.8334 7.50065C12.8334 4.55513 10.4456 2.16732 7.50004 2.16732ZM0.833374 7.50065C0.833374 3.81875 3.81814 0.833984 7.50004 0.833984C11.1819 0.833984 14.1667 3.81875 14.1667 7.50065C14.1667 11.1826 11.1819 14.1673 7.50004 14.1673C3.81814 14.1673 0.833374 11.1826 0.833374 7.50065ZM7.50004 3.50065C7.86823 3.50065 8.16671 3.79913 8.16671 4.16732V7.22451L9.97145 9.02925C10.2318 9.2896 10.2318 9.71171 9.97145 9.97206C9.7111 10.2324 9.28899 10.2324 9.02864 9.97206L7.02864 7.97206C6.90361 7.84703 6.83337 7.67746 6.83337 7.50065V4.16732C6.83337 3.79913 7.13185 3.50065 7.50004 3.50065Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.85c52cb3cac2432647231334399c803b.svg";
export { ForwardRef as ReactComponent };